// needed for coverage; can't mock window.location.reload
export const reloadWindow = () => window.location.reload();
